import React from 'react';
import PhoneInput from "react-phone-input-2";

interface PhoneNumberDisplayProps {
  phone: string | null | undefined;
  textColor?: string;
  country?: string; // Allows the user to specify the default country code
  disableDropdown?: boolean; // Allow showing the country dropdown
  disableCountryCode?: boolean; // Option to disable country code prefix
  enableAreaCodes?: boolean; // Option to enable area codes
  readonly?: boolean; 
}

const PhoneNumberDisplay: React.FC<PhoneNumberDisplayProps> = ({
  phone,
  textColor = "text-text-color",
  country = "US", // Default country set to 'US'
  disableDropdown = true,
  disableCountryCode = false,
  enableAreaCodes = false,
}) => {
  if (!phone) return <p style={{ color: textColor }}>N/A</p>; // Handle missing phone number

  return (
    <PhoneInput
      value={phone}
      country={country} // Dynamically set the default country
      disableDropdown={disableDropdown} // Allow disabling country dropdown
      enableAreaCodes={enableAreaCodes} // Option to allow extra area codes
      disableCountryCode={disableCountryCode} // Option to disable country code display
      inputStyle={{
        padding: "0",
        border: "none", // Remove border from input
        boxShadow: "none", // Remove shadow
        color: textColor, // Use dynamic text color
      }}
      containerStyle={{
        display: "flex",
      }}
      buttonStyle={{
        display: "none", // Hide the flag button
      }}
      inputClass="!text-text-color !bg-bg-color"
      disabled={true}
    />
  );
};

export default PhoneNumberDisplay;
